"use client";

import confetti from "canvas-confetti";
import { useEffect } from "react";

/**
 * Fires a celebratory confetti burst on mount. Ported from the retired
 * CheckoutSuccessModal. Renders nothing — canvas-confetti manages its own
 * full-window canvas. Unlike the modal version, this clears its timeouts on
 * unmount so a fast unmount/remount can't fire stale bursts.
 */
export const ConfettiEffect = () => {
  useEffect(() => {
    const scalar = 0.8;
    const triangle = confetti.shapeFromPath({ path: "M0 10 L5 0 L10 10 Z" });
    const spike = confetti.shapeFromPath({ path: "M0 10 L5 0 L6 10 Z" });
    const wave = confetti.shapeFromPath({ path: "M0 5 Q2.5 0 5 5 T10 5" });
    const circle = confetti.shapeFromPath({
      path: "M5 0 A5 5 0 1 0 5 10 A5 5 0 1 0 5 0 Z",
    });
    const smallDot = confetti.shapeFromPath({
      path: "M3 0 A3 3 0 1 0 3 6 A3 3 0 1 0 3 0 Z",
    });

    const defaults = {
      spread: 360,
      ticks: 90,
      gravity: 0.4,
      decay: 0.94,
      startVelocity: 25,
      scalar,
      colors: ["#ff5722", "#4caf50", "#ffc107"],
      shapes: [triangle, spike, wave, circle, smallDot],
    };

    const shoot = () => {
      confetti({ ...defaults, particleCount: 20 });
      confetti({ ...defaults, particleCount: 15, startVelocity: 5 });
    };

    const timers = [
      setTimeout(shoot, 0),
      setTimeout(shoot, 200),
      setTimeout(shoot, 400),
    ];

    return () => {
      for (const t of timers) clearTimeout(t);
    };
  }, []);

  return null;
};
